function Pattern() {
}

Pattern.events = {
    isInit: true,

    init: function() {
        var self = this;
        var parent = $("#primary_options_container");

        if (self.isInit) {
            $(parent).on("click", ".pattern-selection-container .select-pattern-type", self.onSelectType);

            $(parent).on("change", ".pattern-mascot-container .change-pattern-mascot-layout", self.onChangeLayout);
            $(parent).on("click", ".pattern-mascot-container .edit-pattern-mascot", self.editPatternMascot);
            $(parent).on("click", ".pattern-mascot-container .edit-pattern-mascot-conflict", self.editConflictingMascot);
            $(parent).on("click", ".pattern-mascot-container .mascot-pattern-selection", self.onSelectPatternMascot);
            $(parent).on("click", ".pattern-mascot-container .remove-mascot-pattern", self.onRemovePatternMascot);
            
            self.isInit = false;
        }

        // Remove Mascot Pattern selected part
        let partName = ['END ONE RING', 'END TWO RING', 'FRONT LOWER POCKET TOP', 'UPPER SIDE', 'BODY'];
        let itemPartLabel = $(".part_label")[0].innerHTML.toUpperCase();

        if (ub.config.sport === '2023 Bag') {
            if (_.contains(partName, itemPartLabel)) {
                $('.select-pattern-type[data-type="mascot"]').remove();
            }
        }
    },

    onSelectType: function() {
        var type = $(this).data("type");

        if (type === "pattern") {
            ProlookPattern.events.showPartPatternModal();
        } else if (type === "mascot") {
            ub.partMascotAsPattern = true;
            InksoftMascot.events.onShowStockMascot();
        } else {
            console.log("Invalid type");
        }
    },

    onChangeLayout: function() {
        var layout = $(this).val();
        var _modifier, _names;

        if (QX7Rule.enabled) {
            _names = QX7Rule.BodyPart.getGroupMatOptionCodes(QX7Rule.activeBodyGroup);
        } else {
            _modifier = ub.funcs.getModifierByIndex(ub.current_part);
            _names = ub.funcs.ui.getAllNames(_modifier.name);
        }

        _.each(_names, function (name) {
            var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(name.toTitleCase());
            if (typeof _settingsObject !== "undefined") {
                if (_settingsObject.mascot_pattern_settings.layout !== layout) {
                    _settingsObject.mascot_pattern_settings.layout = layout;

                    PatternMascot.utilities.renderForMaterialOption(
                        _settingsObject.code,
                        _settingsObject.pattern.mascot,
                        _settingsObject.pattern.opacity,
                        _settingsObject.pattern.position,
                        _settingsObject.pattern.rotation,
                        _settingsObject.pattern.scale,
                        _settingsObject
                    );
                }
            }
        });
    },

    editPatternMascot: function() {
        var design_id = $(this).data("design-id");
        ub.data.isEditing = true;
        ub.partMascotAsPattern = true;

        if (typeof design_id !== "undefined") {
            InksoftMascot.funcs.onShowEditDesignModal(design_id, undefined, function() {
                UIkit.modal("#inksoft-design-editor-modal").show();
            });
        }
    },

    editConflictingMascot: function() {
        var design_id = $(this).data("design-id");
        ub.data.isEditing = true;
        ub.partMascotAsPattern = true;

        var _modifier = ub.funcs.getModifierByIndex(ub.current_part);
        var _names = ub.funcs.ui.getAllNames(_modifier.name);
        var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(_names[0].toTitleCase());

        if (typeof _settingsObject !== "undefined") {
            var colorConflict = ub.funcs.hasConflict(_settingsObject.mascot_pattern.design_details);
            
            if (colorConflict._hasConflict) {
                var colors = colorConflict._conflictColors

                InksoftMascot.funcs.onShowEditDesignConflict(design_id, undefined, function() {
                    InksoftMascot.uiHandler.renderConflictColors({
                        colors: colors
                    });
                    
                    UIkit.modal("#inksoft-design-editor-modal-with-conflict").show();
                });
            }
        } else {
            if (typeof design_id !== "undefined") {
                InksoftMascot.funcs.onShowEditDesignModal(design_id, undefined, function() {
                    UIkit.modal("#inksoft-design-editor-modal").show();
                });
            }
        }
    },

    onSelectPatternMascot: function() {
        ub.data.isEditing = true;
        ub.partMascotAsPattern = true;
        InksoftMascot.events.onShowStockMascot();
    },

    onRemovePatternMascot: function() {
        Pattern.core.removeMascotPattern(ub.current_part, function() {
            ub.funcs.activatePatterns();
        })
    }
};

Pattern.partEvents = {
    isInitPartEvents: true,

    init: function() {
        var self = Pattern.partEvents;
        var parent = $("#primary_options_container");
        
        // fix if default color is been remove and added a new colors
        var time = setTimeout(function() {
            $(".pattern-part-container .layer-container").find(".uk-grid.uk-grid-small.grid-tiny").each(function(i, item) {
                $(item).find('div').each(function() {
                    $(item).find('a.uk-active').click();

                    if (!$(this).find('a').hasClass('uk-active')) {
                        $($(item).find('div')[i]).find('a').click();
                    }
                });
            });

            clearTimeout(time);
        }, 300);

        if (self.isInitPartEvents) {
            $(parent).on("click", ".pattern-part-container .select-part-pattern", self.onSelectPattern);
            $(parent).on("click", ".pattern-part-container .select-color-button", self.onSelectColor);

            self.isInitPartEvents = false;
        }
    },

    onSelectPattern: function() {
        ProlookPattern.events.showPartPatternModal();
    },

    onSelectColor: function() {
        var layerNumber = $(this).closest(".layer-container").data("layer-number");
        var selectColor = $(this).data("color-code");
        var colorObject = ub.funcs.getColorByColorCode(selectColor);

        if (colorObject.color_code === selectColor) {
            Pattern.core.changePartPatternColor(ub.current_part, layerNumber, colorObject);

            Pattern.core.changePatternPreviewColor(layerNumber, selectColor, function(image) {
                $(".modifier_main_container .pattern-part-container").find(".pattern-preview-container img").prop("src", image);
            });

            $(".pattern-part-container .layer-container[data-layer-number='"+ layerNumber +"']")
                .find(".select-color-button.uk-active")
                .removeClass("uk-active")
                .html("");

            $(this).addClass("uk-active");
            $(this).html('<span class="fa fa-check fa-1x color-pallete-check" style="color: #'+ colorObject.forecolor +'"></span>');
        } else {
            console.log("Wrong color code");
        }
    }
};

Pattern.applicationEvents = {
    currrentApplication: null,

    init: function(applicationSettings) {
        var self = this;
        Pattern.applicationEvents.currrentApplication = applicationSettings;

        var eventContainer = $(".application-pattern-color-wheel");
        // Show Pattern Modal
        $("circle.preview", eventContainer).on("click", self.onShowPatternModal);
        // Select Color
        $("path.color-wheel-path", eventContainer).on("click", self.onSelectColor);
        // Paginate Layers
        $(".application-pattern-layers a.paginate").on("click", self.onPaginateLayers);
    },

    onShowPatternModal: function() {
        ProlookPattern.events.showApplicationPatternModal(Pattern.applicationEvents.currrentApplication);
    },

    onSelectColor: function() {
        var that = this;
        var layer_number = $(".application-pattern-layers li a.layer-number").data("current-layer");
        var color_code = $(this).data("color-code");
        var applicationSettings = Pattern.applicationEvents.currrentApplication;

        ApplicationCore.funcs.changeApplicationPatternColor(applicationSettings, color_code, layer_number, function() {
            $(".application-pattern-color-wheel path").removeClass("active");
            $(that).addClass("active");

            Pattern.core.changePatternPreviewColor(layer_number, color_code, function(preview) {
                var container = $(".application-pattern-color-wheel .svg-color-wheel");
                $("pattern#image > image", container).attr("xlink:href", preview);
            });
        });
    },

    onPaginateLayers: function() {
        var layerObj;
        var type = $(this).data("type");
        var patternObject = Pattern.applicationEvents.currrentApplication.pattern_obj;
        var count = _.size(patternObject.layers);

        if (type === "previous") {
            if (patternObject.currentLayer > 1) {
                patternObject.currentLayer--;
            } else {
                patternObject.currentLayer = count;
            }

            layerObj = _.find(patternObject.layers, {layer_no: patternObject.currentLayer});
        } else if (type === "next") {
            if (patternObject.currentLayer < count) {
                patternObject.currentLayer++;
            } else {
                patternObject.currentLayer = 1;
            }

            layerObj = _.find(patternObject.layers, {layer_no: patternObject.currentLayer});
        }

        if (typeof layerObj !== "undefined") {
            $(".application-pattern-layers li a.layer-number").data("current-layer", layerObj.layer_no);
            $(".application-pattern-layers li a.layer-number h5").html("");
            $(".application-pattern-layers li a.layer-number h5").html("Color " + layerObj.layer_no + " of " + count);

            // Activate Layer Color
            $(".application-pattern-color-wheel path").removeClass("active");
            $(".application-pattern-color-wheel path[data-color-code='"+ layerObj.color_code +"']").addClass("active");
        }
    }
};

Pattern.core = {
    changePatternPosition: function(code, position) {
        var _viewObjects = Pattern.utilities.getMaterialOptionMascotPatternObject(code);
        var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(code.toTitleCase());

        if (code.includes("left") || code.includes("right")) {
            Pattern.core.changeMatchingPartPatternPosition(code, position);
        }

        _.each(_viewObjects, function (viewObject) {
            var _positionY = (0 + parseInt(position));
            viewObject.position.y = _positionY;
            _settingsObject.mascot_pattern_settings.position = viewObject.position;
        });
    },

    changeMatchingPartPatternPosition: function(code, position) {
        // If part pattern has matching part
        var _matchingViewObjects;
        var _matchingSettingsObject;
        var matchcode;
        var hasMatchingPart = false;

        // Check if has matching parts
        if (code.includes("left")) {
            matchcode = code.replace("left", "right");
            hasMatchingPart = true;
        } else if (code.includes("right")) {
            matchcode = code.replace("right", "left");
            hasMatchingPart = true;
        }

        // If has matching part get Material option setting object & material option pattern view object
        if (hasMatchingPart) {
            _matchingViewObjects = Pattern.utilities.getMaterialOptionMascotPatternObject(matchcode);
            _matchingSettingsObject = ub.funcs.getMaterialOptionSettingsObject(matchcode.toTitleCase());

            if (typeof _matchingViewObjects !== "undefined") {
                _.each(_matchingViewObjects, function (viewObject) {
                    var _positionY = (0 + parseInt(position));
                    viewObject.position.y = _positionY;
                    _matchingSettingsObject.mascot_pattern_settings.position = viewObject.position;
                });
            }
        } else {
            return;
        }
    },

    changePatternOpacity: function(code, opacity) {
        var _viewObjects = Pattern.utilities.getMaterialOptionMascotPatternObject(code);
        var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(code.toTitleCase());

        if (code.includes("left") || code.includes("right")) {
           var matchcode = Pattern.utilities.getMatchingPart(code);

           if (typeof matchcode !== "undefined") {
               Pattern.core.changeMatchingPartPatternOpacity(matchcode, opacity);
           }
        }

        if (typeof _viewObjects !== "undefined" && typeof _settingsObject !== "undefined") {
            _.each(_viewObjects, function (viewObject) {
                viewObject.alpha = opacity;
                _settingsObject.mascot_pattern_settings.opacity = opacity;
            });
        }
    },

    changeMatchingPartPatternOpacity: function(matchcode, opacity) {
        _matchingViewObjects = Pattern.utilities.getMaterialOptionMascotPatternObject(matchcode);
        _matchingSettingsObject = ub.funcs.getMaterialOptionSettingsObject(matchcode.toTitleCase());

        if (typeof _matchingViewObjects !== "undefined") {
            _.each(_matchingViewObjects, function (viewObject) {
                viewObject.alpha = opacity;
                _matchingSettingsObject.mascot_pattern_settings.opacity = opacity;
            });
        }
    },

    changeMascotPatternscale: function(code, scale) {
        var _viewObjects = Pattern.utilities.getMaterialOptionMascotPatternObject(code);
        var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(code.toTitleCase());

        if (code.includes("left") || code.includes("right")) {
           var matchcode = Pattern.utilities.getMatchingPart(code);

            if (typeof matchcode !== "undefined") {
               Pattern.core.changeMatchingPartMascotPatternscale(matchcode, scale);
            }
        }   

        if (typeof _viewObjects !== "undefined" && typeof _settingsObject !== "undefined") {
            _.each(_viewObjects, function (viewObject) {
                if (typeof viewObject.children !== "undefined") {
                    _.each(viewObject.children, function (child) {
                        child.scale = {
                            x: scale,
                            y: scale
                        }
                    });
                }
            });

            _settingsObject.mascot_pattern_settings.scale = {
                x: scale,
                y: scale
            };
        }
    },

    changeMatchingPartMascotPatternscale: function(matchcode, scale) {
        var matchingViewObjects = Pattern.utilities.getMaterialOptionMascotPatternObject(matchcode);
        var matchingSettingsObject = ub.funcs.getMaterialOptionSettingsObject(matchcode.toTitleCase());

        if (typeof matchingViewObjects !== "undefined" && typeof matchingSettingsObject !== "undefined") {
            _.each(matchingViewObjects, function (viewObject) {
                if (typeof viewObject.children !== "undefined") {
                    _.each(viewObject.children, function (child) {
                        child.scale = {
                            x: scale,
                            y: scale
                        };
                    });
                }
            });

            var patternSettings = matchingSettingsObject.mascot_pattern_settings;

            if (typeof patternSettings !== "undefined") {
                patternSettings.scale = {
                    x: scale,
                    y: scale
                };
            }
        }
    },

    removeMascotPattern: function(currentPart, callback) {
        var _modifier = ub.funcs.getModifierByIndex(currentPart);
        var _names = ub.funcs.ui.getAllNames(_modifier.name);

        _.each(_names, function (name) {
            var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(name.toTitleCase());
            if (typeof _settingsObject !== "undefined") {
                delete _settingsObject.mascot_pattern_settings;
                delete _settingsObject.mascot_pattern;
                delete _settingsObject.pattern.mascot;

                _settingsObject.pattern.pattern_id = "blank";
                _settingsObject.pattern.pattern_obj = _.find(ub.data.patterns.items, {code: "blank"});

                _.each(ub.views, function(view) {
                    if (typeof ub.objects[view + "_view"]["patternMascot_" + _settingsObject.code] !== "undefined") {
                        ub[view + "_view"].removeChild(ub.objects[view + "_view"]["patternMascot_" + _settingsObject.code]);
                        delete ub.objects[view + "_view"]["patternMascot_" + _settingsObject.code];
                    }
                });
            }
        });

        if (_.isFunction(callback)) {
            callback();
        }
    },

    patternPreviewForApplication: function(pattern, patternElement, height, width, callback) {
        var canvas = new fabric.Canvas(patternElement);
        ub.data.previewCanvas = canvas;
        
        canvas.setHeight(height);
        canvas.setWidth(width);

        _.each(pattern.layers, function (layer) {
            var layer_number = layer.layer_no;
            var color = "#" + util.padHex((layer.default_color).toString(16),6);
            var localName = "/images/patterns/" + pattern.name + "/" + layer_number + ".png";

            fabric.Image.fromURL(localName, function (image) {
                ub.data.previewContainer[layer_number] = image;
                canvas.add(image);

                if (pattern.code !== "none" && pattern.code !== "blank") {
                    image.filters.push(new fabric.Image.filters.Tint({
                        color: color,
                        opacity: 1,
                    }));
                    
                    image.applyFilters(canvas.renderAll.bind(canvas));
                }

                canvas.renderAll();
            });
        });

        _.delay(function() {
            if (_.isFunction(callback)) {
                var dataURL = canvas.toDataURL();
                callback(dataURL);
            }
        }, 1700);
    },

    changePatternPreviewColor: function(layer_number, color_code, callback) {
        var canvas = ub.data.previewCanvas;
        var image = ub.data.previewContainer[layer_number];
        var colorObj = ub.funcs.getColorByColorCode(color_code);

        if (typeof image !== "undefined") {
            delete image.filters[0];

            image.filters.push(new fabric.Image.filters.Tint({
                color: "#" + colorObj.hex_code,
                opacity: 1,
            }));

            image.applyFilters(canvas.renderAll.bind(canvas));
            canvas.renderAll();

            setTimeout(function() {
                var dataURL = canvas.toDataURL();

                if (_.isFunction(callback)) {
                    callback(dataURL);
                }
            }, 100);
        } else {
            console.log("Cannot find image layer");
        }
    },

    changePartPatternColor: function(currentPartID, layer_id, colorObject) {
        var modifierObject = ub.funcs.getModifierByIndex(currentPartID);
        var listOfPartNames = ub.funcs.ui.getAllNames(modifierObject.name);
        var tintColor = ub.funcs.hexCodeToTintColor(colorObject.hex_code);

        _.each(listOfPartNames, function (partName) {
            var materialSettingsObject = ub.funcs.getMaterialOptionSettingsObject(partName.toTitleCase());
            if (materialSettingsObject) {
                var patternSettings = materialSettingsObject.pattern;
                var layerObject = _.find(patternSettings.pattern_obj.layers, {layer_no: layer_id.toString()});

                if (typeof layerObject !== "undefined") {
                    layerObject.color = tintColor;
                    layerObject.color_code = colorObject.color_code;
                    layerObject.colorObj = colorObject;
                    layerObject.default_color = colorObject.hex_code;
                }

                var materialOptions = ub.funcs.getMaterialOptions(partName.toTitleCase());

                if (_.size(materialOptions) > 0) {
                    _.each(materialOptions, function (materialOption) {
                        var materialOptionName = materialOption.name;
                        var uniformType = ub.current_material.material.type;
                        var containerObject = ub.current_material.containers[uniformType][materialOptionName].containers;
    
                        _.each(ub.views, function (view) {
                            containerObject[view].container.children[layer_id - 1].tint = tintColor;
                        });
                    });
                } else {
                    console.log("Material option list is empty");
                }
            }
        });
    }
};

Pattern.utilities = {
    opacitySlider: function(settings) {
        var opacitySliders = document.querySelector(".part-mascot-pattern-opacity");
        var mascotSetting = settings.mascot_pattern_settings;
        var start = 100;

        var labelsOpacity = {
            first: "1",
            last: "100",
            rest: ""
        }

        if (typeof mascotSetting !== "undefined") {
            start = mascotSetting.opacity * 100;
        }

        SliderCore.rangeSlider(opacitySliders, start, labelsOpacity, function(value) {
            var opacity = value / 100;
            Pattern.core.changePatternOpacity(settings.code, opacity);
        });
    },

    positionSlider: function(settings) {
        var positionSlider = document.querySelector(".part-mascot-pattern-position");
        var mascotSetting = settings.mascot_pattern_settings;

        // For Position
        var max = 100;
        var min = -350;
        var start = min;


        if (typeof mascotSetting !== "undefined") {
            start = mascotSetting.position.y;
        }

        var labelsPosition = {
            first: "Up",
            last: "Down",
            rest: ""
        }

        SliderCore.rangeSlider(positionSlider, start, labelsPosition, function(value) {
            Pattern.core.changePatternPosition(settings.code, value);
        }, min, max);
    },

    scaleSlider: function(settings) {
        var scaleSliders = document.querySelector(".part-mascot-pattern-size");
        var mascotSetting = settings.mascot_pattern_settings;
        var start = 10;

        if (typeof mascotSetting !== "undefined") {
            start = mascotSetting.scale.x * 100;
        }

        var labelsSize = {
            first: "Small",
            last: "Large",
            rest: ""
        }

        SliderCore.rangeSlider(scaleSliders, start, labelsSize, function(value) {
            var scale = value / 100;
            Pattern.core.changeMascotPatternscale(settings.code, scale);
        });
    },

    getMaterialOptionMascotPatternObject: function(materialOptionName) {
        var _viewObjects = [];

        _.each (ub.views, function (view) {

            var _obj = ub.objects[view + '_view']['patternMascot_' + materialOptionName.toCodeCase()];

            if (typeof _obj !== "undefined") {
                _viewObjects.push(_obj);
            }

        })

        return _viewObjects;
    },

    getMatchingPart: function(code) {
        var matchcode;

        if (code.includes("left")) {
            matchcode = code.replace("left", "right");
        } else if (code.includes("right")) {
            matchcode = code.replace("right", "left");
        }

        return matchcode;
    },

    setupPartPatternPositionSlider: function(patternObject, materialOption) {
        var _partSettingsObject = ub.funcs.getMaterialOptionSettingsObject(materialOption.name);
        var start = ub.uiData.patternSliderRange.starts;
        var _patternIsForCalibration = false;
        var offsetMin, offsetMax;
        var _offset = ub.uiData.patternOffset.getOffset(patternObject.pattern_id, ub.config.blockPattern, _partSettingsObject.code);
        _patternIsForCalibration = _.contains(ub.uiData.patternSliderRange.forCalibration, patternObject.name);
    
        if (typeof _partSettingsObject.pattern !== "undefined" && _partSettingsObject.pattern.length > 0) {
            start = _partSettingsObject.pattern.position.y;
    
            if (_patternIsForCalibration) {
                start -= _patternIsForCalibration;
            }
        } else {
            start = _partSettingsObject.pattern.position.y;
        }
    
        if (typeof _offset !== "undefined" && typeof _partSettingsObject.pattern.dirty === "undefined") {
            start = _offset.offSet;
            ub.funcs.changePartPatternPosition(materialOption.name, start, true);
    
            offsetMax = _offset.max;
            offsetMin = _offset.min;
        }

        var minimumDiff = 325;
        var maximumDiff = 760;
    
        // Connected to the saved design's pattern issues in generate_pattern funcs
        var _neckOptions = ['Neck Gaiter']; // RDL Face Mask
        if (_.contains(_neckOptions, ub.config.option)) {
            var position = (typeof offsetMin !== "undefined") ? offsetMin : minimumDiff;
            ub.funcs.changePartPatternPosition(materialOption.name, position);   
        }
    
        var positionSlider = document.querySelector(".part-pattern-slider-position");
        var labelsPosition = {
            first: "Up",
            last: "Down",
            rest: ""
        };
    
        var min = typeof offsetMin !== "undefined" ? offsetMin : minimumDiff;
        var max = typeof offsetMax !== "undefined" ? offsetMax : maximumDiff;
    
        SliderCore.rangeSlider(positionSlider, start, labelsPosition, function(value) {
            ub.funcs.changePartPatternPosition(materialOption.name, value);
        }, min, max);
    }
};


Pattern.renderBlank = function() {
    var tmpl = _.template($("#pattern-selection-template").html());
    $('.modifier_main_container').append(tmpl());
    Pattern.events.init();
};

Pattern.renderPartPatternMascot = function(mascot, materialOptionSettings) {
    var design_details = mascot.design_details;
    var colorConflict = ub.funcs.hasConflict(design_details);
    
    if (colorConflict._hasConflict) {
        var colors = colorConflict._conflictColors
        Pattern.renderConflictColors(mascot.design_id, colors);

        return;
    }

    if (typeof materialOptionSettings !== "undefined") {
        var tmpl = _.template($("#pattern-mascot-template").html());
        $('.modifier_main_container').append(tmpl({
            part_name: materialOptionSettings.code.toTitleCase(),
            thumbnail: mascot.png_filename,
            design_id: mascot.design_id,
            design_name: mascot.name,
            svg_url: mascot.svg_filename,
            layout: materialOptionSettings.mascot_pattern_settings.layout
        }));

        Pattern.utilities.scaleSlider(materialOptionSettings);
        Pattern.utilities.positionSlider(materialOptionSettings);
        Pattern.utilities.opacitySlider(materialOptionSettings);

        Pattern.events.init();
    } else {
        console.log("Please provide material option settings");
    }
};

Pattern.renderConflictColors = function(design_id, conflictingColors) {
    var tmpl = _.template($("#pattern-mascot-conflict-colors-template").html());

    $('.modifier_main_container').append(tmpl({
        conflictingColors: conflictingColors,
        design_id: design_id
    }));

    Pattern.events.init();
};

Pattern.renderPatternUI = function(patternObject, materialOptionSettings) {
    var tmpl = _.template($("#pattern-part-template").html());
    var part = ub.funcs.getModifierByIndex(ub.current_part);
    $('.modifier_main_container').append(tmpl({
        colors: ub.current_material.settings.team_colors,
        pattern: patternObject.pattern_obj,
        part: part
    }));

    Pattern.partEvents.init();
    Pattern.utilities.setupPartPatternPositionSlider(patternObject, materialOptionSettings);

    Pattern.core.patternPreviewForApplication(patternObject.pattern_obj, "partPatternPreview", 300, 300, function(image) {
        $(".modifier_main_container .pattern-part-container").find(".pattern-preview-container img").prop("src", image);

        // Hide Loader and Show Preview
        $(".modifier_main_container .pattern-part-container").find(".pattern-preview-container").removeClass("uk-hidden");
        $(".modifier_main_container .pattern-part-container").find(".part-pattern-loading").addClass("uk-hidden");
    });
};

